import React from "react";
import { useNavigate } from "react-router-dom";

import ForgotPasswordPage from "../../components/auth/ForgotPasswordPage";

const ForgotPasswordRoute = () => {
  const navigate = useNavigate();
  return <ForgotPasswordPage onBackToLogin={() => navigate("/login")} />;
};

export default ForgotPasswordRoute;
